import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Menu } from 'antd';
import { CloudDownloadIcon } from '../../../custom_shared/icons';

const key = 'export-to-json';

interface Props {
    onClick: () => void;
}

const ExportToJsonMenuItem: React.FC<Props> = ({ onClick }) => {
    return (
        <Menu.Item key={key} eventKey={key} icon={<CloudDownloadIcon />} onClick={onClick}>
            Export To JSON
        </Menu.Item>
    );
};

export default observer(ExportToJsonMenuItem);
